var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AdvertisementsStates"},[_c('CircleDisplay',{staticClass:"Circle",attrs:{"title":_vm.$t('advertisements.percentages-states'),"options":_vm.options,"series":_vm.sectors}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }